import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OnboardingStatusService } from '../features/onboarding/services/onboarding-status.service';

export const userOnboardingSubmittedGuard: CanActivateFn = () => {
  const status = inject(OnboardingStatusService);
  const router = inject(Router);

  return status.hasPersonalKycSubmission() ? router.createUrlTree(['/home']) : true;
};
